












































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "../../../lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import Organizationpo from "@/store/entities/basedata/organizationpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import organization from "@/store/modules/basedata/organization";

@Component({
  components: { TreeSelect },
})
export default class CreateItemDetail extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  organization: Organizationpo = new Organizationpo();
  loading: boolean = false;

  created() {
    this.itemDetail();
    this.itemtree();
    this.organization.isEnable = 1;
  }

  create() { }
  save() {
    (this.$refs.orgForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store.dispatch({
          type: "organization/create",
          data: this.organization,
        }).catch((err) => {
          this.loading = false;
        });
        this.loading = false;
        (this.$refs.orgForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.orgForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemDetail() {
    await this.$store
      .dispatch({
        type: "itemdetail/getdetaillist",
        data: 1,
      })
      .then((val) => {
        this.$data.itemdetail = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async itemtree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  itemRule = {
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    code: [
      {
        required: true,
        message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    itemDetailId: [
      {
        required: true,
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      itemdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
